import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { ACTION_TYPES } from "@/lib/const";
import {
  InputPaymentPackageCreate,
  InputPaymentPackageUpdate,
  PaymentPackage,
} from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";

export const storePath = "settings/paymentPackages";
const Store = namespace(storePath);

@Component
export default class WithPaymentPackages extends Vue {
  @Store.Action(ACTION_TYPES.GET_DATA)
  public paymentPackagesFindAll!: (payload: { type?: string[] }) => Promise<PaymentPackage[]>;

  @Store.Action(ACTION_TYPES.ADD_DATA)
  public paymentPackagesCreate!: (payload: { data: InputPaymentPackageCreate }) => Promise<PaymentPackage>;

  @Store.Action(ACTION_TYPES.SET_DATA)
  public paymentPackagesUpdate!: (payload: { data: InputPaymentPackageUpdate }) => Promise<PaymentPackage>;

  @Store.Action(ACTION_TYPES.DEL_DATA)
  public paymentPackagesDelete!: (payload: { packageId: string }) => Promise<boolean>;
}
